import { ReactElement } from "react"
import AutoLinker from "autolinker"
import xss from "xss"
import styled from "styled-components"
import { Color } from "~/consts/style-mixins"

type Props = {
  children: string,
  className?: string
}

const AutoLink = ({ children, className }: Props): ReactElement => {
  const linkedText = { __html: AutoLinker.link(xss(children), { stripPrefix: false }) }

  return <Container dangerouslySetInnerHTML={linkedText} className={className} />
}

const Container = styled.div`
  a {
    color: ${Color.Secondary};
  }
`

export default AutoLink
